import React, { useState } from "react";
import Header from "./Header";

function Registration({ event }) {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    organization: "",
    attendance_type: "",
    role: "",
    country: "",
    recieve_updates: false,
    photo_consent: false,
  });

  const [organizations, setOrganizations] = useState([]);

  const fetchOrganizations = async (query) => {
    if (query.length < 3) {
      setOrganizations([]);
      return;
    }

    const res = await fetch(
      `https://www.wikidata.org/w/api.php?action=wbsearchentities&search=${encodeURIComponent(
        query,
      )}&language=en&format=json&origin=*`,
    );

    const data = await res.json();
    setOrganizations(data.search || []);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch(
        `/api/events/${event.event_slug}/registration/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );

      const data = await response.json();

      if (response.ok) {
        setMessage(
          data.message ||
            "You have successfully registered for the workshop.",
        );
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          organization: "",
          role: "",
          country: "",
        });
        setTimeout(() => {
          window.location.href = `/events/${event.event_slug}/`;
        }, 5000);
      } else {
        let errorMessage = "An error occurred. Please try again.";

        if (data.error) {
          errorMessage = data.error;
        } else if (typeof data === "object") {
          const firstKey = Object.keys(data)[0];
          const firstError = data[firstKey][0];
          errorMessage = firstError;
        }

        setMessage(errorMessage);
      }
    } catch (error) {
      setMessage("Network error: " + error.message);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <Header />
      <div className=" p-6">
        <div className=" max-w-5xl mx-auto text-center px-4 mb-12">
          <h3
            key={event.id}
            className="text-3xl font-bold text-gray-900 leading-tight"
          >
            Register for the {event.name}
          </h3>

          <p className="text-gray-600 mt-4 text-base leading-relaxed">
            This workshop is ideal for professionals and organizations seeking
            to strengthen their innovation capability through structured,
            standards-based approaches.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mx-auto grid max-w-lg grid-cols-1 gap-6 rounded-lg border border-gray-300 bg-gray-100 p-6 sm:grid-cols-2 mt-10">
            <div>
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="first_name"
              >
                First Name
              </label>

              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="first_name"
                type="text"
                placeholder="Your name"
                value={formData.first_name}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="last_name"
              >
                Last Name
              </label>

              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="last_name"
                type="text"
                placeholder="Your name"
                value={formData.last_name}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="email"
              >
                Email
              </label>
              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="email"
                type="email"
                placeholder="Your email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="phone_number"
              >
                Phone Number
              </label>

              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="phone_number"
                type="tel"
                placeholder="Your phone Number"
                value={formData.phone_number}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="text-sm font-medium text-gray-900"
                htmlFor="attendance_type"
              >
                Attendance Type
              </label>

              <label className="flex items-center gap-2 block text-sm font-medium text-gray-900">
                <input
                  type="radio"
                  name="attendance_type"
                  value="Delegate"
                  className="h-4 w-4 text-blue-600"
                  id="attendance_type"
                  onChange={handleChange}
                  checked={formData.attendance_type === "Delegate"}
                />
                <span>Delegate</span>
              </label>

              <label className="flex items-center gap-2 block text-sm font-medium text-gray-900">
                <input
                  type="radio"
                  name="attendance_type"
                  value="Facilitator"
                  className="h-4 w-4 text-blue-600"
                  id="attendance_type"
                  checked={formData.attendance_type === "Facilitator"}
                  onChange={handleChange}
                />
                <span>Facilitator</span>
              </label>

              <label className="flex items-center gap-2 block text-sm font-medium text-gray-900">
                <input
                  type="radio"
                  name="attendance_type"
                  value="Organizer"
                  className="h-4 w-4 text-blue-600"
                  id="attendance_type"
                  checked={formData.attendance_type === "Organizer"}
                  onChange={handleChange}
                />
                <span>Organizers</span>
              </label>
            </div>

            <div className="md:col-span-2">
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="organization"
                aria-required
              >
                Organization
              </label>

              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="organization"
                type="text"
                placeholder="Search For Your Organization"
                value={formData.organization}
                required
                onChange={(e) => {
                  handleChange(e);
                  fetchOrganizations(e.target.value);
                }}
              />
              <p className="text-xs text-gray-500 mt-1">
                Can’t find your organization? Just type it and continue.
              </p>
            </div>
            {organizations.length > 0 && (
              <ul className="border border-gray-200 mt-1 rounded bg-white max-h-48 overflow-y-auto">
                {organizations.map((org) => (
                  <li
                    key={org.id}
                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                    onClick={() => {
                      setFormData({
                        ...formData,
                        organization: org.label,
                      });
                      setOrganizations([]);
                    }}
                  >
                    <div className="font-medium">{org.label}</div>
                  </li>
                ))}
              </ul>
            )}

            <div className="md:col-span-2">
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="role"
              >
                Role in Organization
              </label>

              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none  p-2"
                id="role"
                type="text"
                placeholder="Your role in the organization"
                value={formData.role}
                onChange={handleChange}
              />
            </div>

            <div className="md:col-span-2">
              <label
                className="block text-sm font-medium text-gray-900"
                htmlFor="country"
              >
                Country
              </label>

              <input
                className="mt-1 w-full  border-gray-300 focus:border-indigo-500 focus:outline-none p-2"
                id="country"
                type="text"
                placeholder="Your country of residence"
                value={formData.country}
                onChange={handleChange}
              />
            </div>

            <div className="md:col-span-2">
              <input
                className="size-5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                id="recieve_updates"
                type="checkbox"
                name="inquiry-type"
                checked={formData.recieve_updates}
                required
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    recieve_updates: e.target.checked,
                  }))
                }
              />

              <label className="ml-3 text-gray-900" htmlFor="recieve_updates" aria-required>
                I agree to receive updates and communication from
                KEBS.
              </label>
            </div>

            <div className="md:col-span-2">
              <input
                className="size-5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                id="photo_consent"
                type="checkbox"
                name="inquiry-type"
                checked={formData.photo_consent}
                required
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    photo_consent: e.target.checked,
                  }))
                }
              />

              <label className="ml-3 text-gray-900" htmlFor="photo_consent" aria-required>
                I agree to allow KEBS to use my photographs and videos taken
                during the workshop for publications, and social media
                content.
              </label>
            </div>

            <div className="md:col-span-2">
              <button
                className="block w-full  border border-indigo-600 bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition-colors hover:bg-transparent hover:text-indigo-600"
                type="submit"
              >
                {isLoading ? "Submitting..." : "Register"}
              </button>
            </div>
          </div>
        </form>
        {message && (
          <div className="max-w-lg mx-auto p-4 mb-4 text-center text-white bg-indigo-600 rounded">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

export default Registration;
